import { useEffect, useRef } from 'react';
import { useMap } from 'react-map-gl/maplibre';

export function MapAutoZoom({ boundingBox, isReady }) {
  const map = useMap();
  const hasZoomed = useRef(false);

  useEffect(() => {
    if (map.current && isReady && boundingBox && !hasZoomed.current) {
      map.current.fitBounds(boundingBox, {
        maxZoom: 16,
        padding: 32,
        duration: 0,
      });
      hasZoomed.current = true;
    }
  }, [boundingBox, isReady, map]);

  return null;
}
